import { render, staticRenderFns } from "./ribbonDropMenuItem.vue?vue&type=template&id=01129a71"
import script from "./ribbonDropMenuItem.vue?vue&type=script&lang=js"
export * from "./ribbonDropMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports